import styles from "./TeamMemberTable.module.css";
import { Spin } from "antd";
import ActionMenu from "../../../../CommonComponents/ActionMenu";
import { ENTERPRISE_COMPANY } from "../../../../../urlConfig";
import DataTableWithFilters from "../../../../CommonComponents/DataTableWithFilters";
import { useLocation, useNavigate } from "react-router-dom";

const TeamMemberTable = ({ height, data, loading }) => {
  const navigate = useNavigate();
  const handleDelete = (record) => {};
  const location = useLocation();

  const handleNavigate = (route) => {
    navigate(route);
  };

  const columns = [
    {
      title: `Team members (${data.length})`,
      dataIndex: "firstName",
      key: "firstName",
      render: (name, record) => {
        return (
          <div
            className={styles.user_image_wrap}
            onClick={() =>
              handleNavigate(
                ENTERPRISE_COMPANY +
                  location.pathname.split("/")[3] +
                  "/member/" +
                  record._id
              )
            }
          >
            {record.firstName} {record.lastName}
          </div>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "emailAddress",
      key: "emailAddress",
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      width: 120,
      render: (department, record) => {
        return (
          <div className={styles.team_cell}>
            {department ? department?.toUpperCase() : "-"}{" "}
          </div>
        );
      },
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (role, record) => {
        return <div className={styles.permission_cell}>{role} </div>;
      },
    },
    {
      title: "",
      dataIndex: "Actions",
      key: "Actions",
      minWidth: 50,
      render: (status, record) => {
        return (
          <div>
            <ActionMenu
              options={[
                {
                  label: "Edit",
                  route:
                    ENTERPRISE_COMPANY +
                    location.pathname.split("/")[3] +
                    "/member/" +
                    record._id,
                },
                // {
                //   label: "Delete",
                //   action: () => handleDelete(record),
                // },
              ]}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className={styles.content_wrap}>
      {!loading ? (
        <DataTableWithFilters
          columns={columns}
          data={data}
          loading={loading}
          hideHeader={true}
          tableKey={"key"}
          hideFooter={true}
          scroll={{
            x: "max-content",
            y: height,
          }}
        />
      ) : (
        <div className={styles.loader_wrap}>
          <Spin />
        </div>
      )}
    </div>
  );
};

export default TeamMemberTable;
